import {Base,Axios} from "@/api/Base"

export class AttendanceLogsExport extends Base {
    path = "attendanceLogs/export"
    download(param = {}) {
        return Axios.get(this.path,{ params: param, responseType: "blob" })
    }
}